import { Box, Card, TextButton } from "@wix/design-system";
import { useTranslation } from "@wix/fe-essentials-standalone";
import { HELP_CENTER_URL, FEEDBACK_URL } from "../../../consts";
import { type FC } from "react";
import { MenuItem } from "../MainMenu/MenuItem";
import { useMobile } from "../../../hooks/useMobile";

interface HelpDropdownProps {
  onClose: () => void;
  isVisible: boolean;
}

export const HelpDropdown: FC<HelpDropdownProps> = ({ onClose, isVisible }) => {
  const { t } = useTranslation();
  const isMobile = useMobile();

  if (!isVisible) {
    return null;
  }

  if (isMobile) {
    return (
      <Box direction="vertical" gap={2} padding={4}>
        <MenuItem
          href={HELP_CENTER_URL}
          onMouseEnter={() => (window.location.href = HELP_CENTER_URL)}
        >
          {t("landing.header.help_center")}
        </MenuItem>
        <MenuItem
          href={FEEDBACK_URL}
          onMouseEnter={() => (window.location.href = FEEDBACK_URL)}
        >
          {t("landing.header.feedback")}
        </MenuItem>
      </Box>
    );
  }

  return (
    <Box
      align="left"
      width="181px"
      height="72px"
      position="absolute"
      {...(document.documentElement.dir === "rtl"
        ? { right: "253px" }
        : { left: "253px" })}
      top="59px"
      zIndex="1000"
    >
      <Card showShadow stretchVertically>
        <Card.Content size="none">
          <Box direction="vertical" gap={3} paddingLeft={4} paddingTop={3}>
            <TextButton
              skin="dark"
              size="small"
              as="a"
              href={HELP_CENTER_URL}
              target="_blank"
              onClick={onClose}
            >
              {t("landing.header.help_center")}
            </TextButton>

            <TextButton
              skin="dark"
              size="small"
              as="a"
              href={FEEDBACK_URL}
              target="_blank"
              onClick={onClose}
            >
              {t("landing.header.feedback")}
            </TextButton>
          </Box>
        </Card.Content>
      </Card>
    </Box>
  );
};
